namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_component_view, {
		
		Widget_head: {
			background: {
				color: $mol_theme.card,
			},
		},

		Content_scroll: {
			userSelect: 'text',
		},

		
	} )
	
}
